export default __webpack_public_path__ + "static/media/cat.971eb973.mp3";